var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.59 4.756a.833.833 0 0 0-1.18-1.179L3.578 9.411a.833.833 0 0 0 0 1.178l5.834 5.834a.833.833 0 0 0 1.178-1.179l-4.41-4.41h9.654a.833.833 0 1 0 0-1.667H6.18z"
  })));
};
export default SvgArrowLeft;